import React, { useCallback } from 'react';
import { Textarea as ORCtextarea } from '@ontruck/orc';

const Textarea = ({ className, value, placeholder, onChange }) => {
  const handleChange = useCallback(
    (_, { value }) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <ORCtextarea
      className={className}
      onChange={handleChange}
      label={placeholder}
      id="textarea"
      height="55px"
      value={value}
      error={null}
    />
  );
};

export default Textarea;
